export const PERMISSIONS = {
    CHANGE_BOX_STATUS: 60,
    PASSWORD_RESET: 61,
    EXPENSE_CONTROL: 62,
    VIEW_EXPENSES_OF_OTHER_USERS: 63,
    EDIT_EXPENSE: 64,
    DELETE_EXPENSE: 65,
    COMMUNICATION_CHANNEL_CUSTOMER: 66,
    RUTEO_AUTOMATICO_ACCESS: 67,
}